import React, { FC } from 'react';
import classNames from 'classnames';

import { Document } from '@contentful/rich-text-types';
import { Badge, LuvImage, RichText } from '@/components';
import { TypeMediaTextTitleFields } from '@/core/generated-types';

import MediaTextTitleModal from '../MediaTextTitle/MediaTextTitleModal';

export interface ValuePropositionProps extends TypeMediaTextTitleFields {
  display?: 'carousel' | 'row';
}

const ValueProposition: FC<ValuePropositionProps> = ({
  image,
  textBody,
  textHeading,
  id,
  display,
  badge,
  modal,
}) => {
  const isCarousel = display === 'carousel';

  return (
    <div
      className={classNames('relative flex', {
        'mx-auto flex-col items-start text-center md:px-8 md:text-left':
          isCarousel,
        'md:mx-auto md:flex-col md:items-start md:px-8 md:text-left':
          !isCarousel,
      })}
      id={id}
    >
      {badge && (
        <div className="absolute z-[1] -top-4">
          <Badge {...badge.fields} />
        </div>
      )}
      <figure
        className={classNames('mb-3 flex-none mx-auto', {
          'pr-3 md:pr-0': !isCarousel,
        })}
      >
        {image && (
          <LuvImage
            imageData={image}
            height={200}
            width={200}
            className="h-auto w-[56px] self-start md:w-[72px]"
            alt=""
          />
        )}
      </figure>
      <div className="flex-grow">
        <div
          className={classNames('md:mb-1 w-full text-lg font-bold md:text-xl', {
            'text-center md:text-left': isCarousel,
          })}
        >
          {textHeading || ''}
        </div>
        {textBody && <RichText content={textBody as Document} />}
        {modal && <MediaTextTitleModal fields={modal.fields} />}
      </div>
    </div>
  );
};

export default React.memo(ValueProposition);
